const period = 25 * 60;

export default period;
